var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._b({staticClass:"decoration-none",attrs:{"href":("tel:" + _vm.phone)}},'a',_vm.$attrs,false),[_vm._t("default",[_vm._v(" "+_vm._s(_vm.phone)+" ")],{"phone":_vm.phone})],2)}
var staticRenderFns = []

export { render, staticRenderFns }